import { render, staticRenderFns } from "./VideoHeroSectionModule.vue?vue&type=template&id=0510050e&"
import script from "./VideoHeroSectionModule.vue?vue&type=script&lang=js&"
export * from "./VideoHeroSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports